/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { IGetMeasure, useGetNearestMeasureIdQuery } from "../../apis/apiSlice";
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { getMeasureTypeName } from '../../model/measure';
import { measureLayerGroup } from '../../reducers/legend';
import { useTypedSelector } from '../../reducers';
import ILegendLayer from '../../model/ILegendLayer';
import { EXISTING_MEASURES_ID, OTHER_EXISTING_MEASURES_ID } from '../../model/layerGroups';

interface IProps {
 pixelX: number; 
 pixelY: number; 
 x: number;
 y: number;  
 radius: number;
 measuresFromApi: Array<IGetMeasure>;
}
export const CellInfoZIndex = 90;
const CellInfoStyle = css`
  position: absolute;
  z-index: ${CellInfoZIndex};
  border: 1px black solid;
  background-color: ${mikeSharedTheme.palette.lightGrey?.main};
  padding: ${mikeSharedTheme.spacing(0.5)};
  color: ${mikeSharedTheme.palette.text.primary};
`;


export const MeasureInfo = (props: IProps) => {
  const {pixelX, pixelY, x,y, radius, measuresFromApi,} = props; 
  const {data, isFetching, isLoading} = useGetNearestMeasureIdQuery({x, y, radius})
  const measureGroup = useTypedSelector(measureLayerGroup);

   const {ownMeasureLayerVisible, otherMeasureLayerVisible} = useMemo(() => {
      const layers = measureGroup?.layer;
      const ownMeasureLayer = layers?.find((l: ILegendLayer) => l.id === EXISTING_MEASURES_ID);
      const otherMeasureLayer = layers?.find((l: ILegendLayer) => l.id === OTHER_EXISTING_MEASURES_ID);
      return {ownMeasureLayerVisible:  ownMeasureLayer === undefined ? false : ownMeasureLayer.visible, otherMeasureLayerVisible: otherMeasureLayer === undefined ? false : otherMeasureLayer.visible}
    },[measureGroup])

  const foundMeasure = useMemo(() => {
    if (!isFetching && !isLoading && data && data.measureId){   
      const measureId = data.measureId
      const measure = measuresFromApi.find((m: IGetMeasure) => m.measureId === measureId)
      if (measure !== undefined){
        const skip = (measure.ownedByUser && !ownMeasureLayerVisible) || (!measure.ownedByUser && !otherMeasureLayerVisible)
        if (!skip){
          return  measure;
        }  
      }
    }
    return null;
  },[data, isFetching, isLoading, measuresFromApi, ownMeasureLayerVisible, otherMeasureLayerVisible])

  const getContent = (m: IGetMeasure) => {
    if (foundMeasure){
      return <div>
      <Typography variant="body2">{"Maßnahmen-ID: " + m.measureId}</Typography>
      <Typography variant="body2">{"Maßnahmentyp: " + getMeasureTypeName(m.measureType)}</Typography>
      <Typography variant="body2">{"Vorhabenträger: " + m.projectDeveloper}</Typography>
    </div>;
    }     
    return null;
  }

  return (
    <>
      {foundMeasure && (
          <div
            css={CellInfoStyle}
            style={{
              bottom: `${pixelY}px`,
              left: `${pixelX}px`,
            }}
          >
            {getContent(foundMeasure)}
          </div>
        )}
    </>
  );
}

export default MeasureInfo;